const layoutElementTypes = Object.freeze({
	HEADER: 'header',
	FOOTER: 'footer',
	MOBILE_NAVIGATION_MENU: 'mobileNavigationMenu',
	CHECKOUT_HEADER: 'checkoutHeader'
});

module.exports = layoutElementTypes;
